import { Amplify } from "aws-amplify";
import config from "./config";

const awsconfig = Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolClientId: config.cognito.APP_CLIENT_ID,
      loginWith: {
        email: true
      }
    }
  },

  Storage: {
    S3: {
      region: config.s3.REGION,
      bucket: config.s3.BUCKET
    }
  },

  API: {
    REST: {
      DocumentsGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_API_URL,
        region: config.s3.REGION
      },
      DocumentsCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      DocumentsListGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_LIST_API_URL,
        region: config.s3.REGION
      },
      DocumentsListCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_LIST_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      DocumentsDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      UpdateDocumentsDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.UPDATE_DOCUMENTS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      GroupesDocumentsDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.GROUPES_DOCUMENTS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      DemandesDetailsDocumentsGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDES_DETAILS_DOCUMENTS_API_URL,
        region: config.s3.REGION
      },
      DemandesGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDES_API_URL,
        region: config.s3.REGION
      },
      DemandesAllGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDES_ALL_API_URL,
        region: config.s3.REGION
      },
      DemandesCopibecAllGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDES_COPIBEC_ALL_API_URL,
        region: config.s3.REGION
      },
      DemandesCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDES_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      DemandesDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDE_DETAILS_API_URL,
        region: config.s3.REGION
      },
      DemandesDetailsApprouveeGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDE_DETAILS_APPROUVEE_API_URL,
        region: config.s3.REGION
      },
      DemandesDetailsRefuseeGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDE_DETAILS_REFUSEE_API_URL,
        region: config.s3.REGION
      },
      DemandesDetailsCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.DEMANDE_DETAILS_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      CreateDemandesDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.CREATE_DEMANDE_DETAILS_API_URL,
        region: config.s3.REGION
      },
      CreateDemandesDetailsApprouveOrRejeteGatewayAPI: {
        endpoint: config.encryptUtilsApi.CREATE_DEMANDE_DETAILS_APPROUVE_REJETE_API_URL,
        region: config.s3.REGION
      },
      DocumentsAchetesUtilisateursGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_ACHETES_UTILISATEURS_API_URL,
        region: config.s3.REGION
      },
      DocumentsCopibecAchetesUtilisateursGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_COPIBEC_ACHETES_UTILISATEURS_API_URL,
        region: config.s3.REGION
      },
      DocumentsAchetesUtilisateursDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_ACHETES_UTILISATEURS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      CommandesAchatsGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMMANDES_ACHATS_API_URL,
        region: config.s3.REGION
      },
      CommandesCopibecAchatsGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMMANDES_COPIBEC_ACHATS_API_URL,
        region: config.s3.REGION
      },
      CommandesAchatsDocumentsDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMMANDES_ACHATS_DOCUMENTS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      CommandesAchatsOrderDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMMANDES_ACHATS_ORDER_DETAILS_API_URL,
        region: config.s3.REGION
      },
      ApproveOrRefuseCommandesAchatsOrderDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.APPROVE_OR_REFUSE_COMMANDES_ACHATS_ORDER_DETAILS_API_URL,
        region: config.s3.REGION
      },
      OrderProductsGatewayAPI: {
        endpoint: config.encryptUtilsApi.ORDER_PRODUCTS_API_URL,
        region: config.s3.REGION
      },
      ResetOrderDownloadsGatewayAPI: {
        endpoint: config.encryptUtilsApi.RESET_ORDER_DOWNLOADS_API_URL,
        region: config.s3.REGION
      },
      HistoriquesRepresentantsGatewayAPI: {
        endpoint: config.encryptUtilsApi.HISTORIQUES_REPRESENTANTS_API_URL,
        region: config.s3.REGION
      },
      HistoriquesCopibecRepresentantsGatewayAPI: {
        endpoint: config.encryptUtilsApi.HISTORIQUES_COPIBEC_REPRESENTANTS_API_URL,
        region: config.s3.REGION
      },
      HistoriquesRepresentantsDocumentsDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.HISTORIQUES_REPRESENTANTS_DOCUMENTS_DETAILS_API_URL,
        region: config.s3.REGION
      },
      HistoriquesRepresentantsOrderDetailsGatewayAPI: {
        endpoint: config.encryptUtilsApi.HISTORIQUES_REPRESENTANTS_ORDER_DETAILS_API_URL,
        region: config.s3.REGION
      },
      PublicationGatewayAPI: {
        endpoint: config.encryptUtilsApi.CREATE_PUPLICATION_API_URL,
        region: config.s3.REGION
      },
      PublishersGatewayAPI: {
        endpoint: config.encryptUtilsApi.PUBLISHERS_API_URL,
        region: config.s3.REGION
      },
      PublishersCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.PUBLISHERS_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      OffresGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.OFFRES_GROUPES_API_URL,
        region: config.s3.REGION
      },
      OffresGroupesCopibecGatewayAPI: {
        endpoint: config.encryptUtilsApi.OFFRES_GROUPES_COPIBEC_API_URL,
        region: config.s3.REGION
      },
      DocumentDetailsOffresGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENT_DETAILS_OFFRES_GROUPES_API_URL,
        region: config.s3.REGION
      },
      CreateDocumentDetailsGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.CREATE_DOCUMENT_DETAILS_GROUPES_API_URL,
        region: config.s3.REGION
      },
      UpdateDocumentDetailsGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.UPDATE_DOCUMENT_DETAILS_GROUPES_API_URL,
        region: config.s3.REGION
      },
      ComboOffresGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMBO_OFFRES_GROUPES_API_URL,
        region: config.s3.REGION
      },
      ComboCopibecOffresGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.COMBO_COPIBEC_OFFRES_GROUPES_API_URL,
        region: config.s3.REGION
      },
      DocumentsGroupesGatewayAPI: {
        endpoint: config.encryptUtilsApi.DOCUMENTS_GROUPES_API_URL,
        region: config.s3.REGION
      },
      RaisonsSuperAdminGatewayAPI: {
        endpoint: config.encryptUtilsApi.RAISONS_SUPER_ADMIN_API_URL,
        region: config.s3.REGION
      },
      RaisonsAdminGatewayAPI: {
        endpoint: config.encryptUtilsApi.RAISONS_ADMIN_API_URL,
        region: config.s3.REGION
      }
    }
  }
});

const awsConfig = { ...awsconfig };

export default awsConfig;
